(() => {
  const mount = document.querySelector('[data-shop-login]');
  if (!mount) return;

  const accountUrl = mount.dataset.accountUrl || '/account';
  let done = false;
  let checking = false;

  const isSignedIn = async () => {
    try {
      const res = await fetch(accountUrl, { redirect: 'manual', credentials: 'same-origin' });
      return res.type !== 'opaqueredirect' && res.ok;
    } catch (e) {
      return false;
    }
  };

  const check = async () => {
    if (done || checking) return;
    checking = true;
    if (await isSignedIn()) {
      done = true;
      window.location.assign(accountUrl);
      return;
    }
    checking = false;
  };

  window.addEventListener('focus', check);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') check();
  });

  const started = performance.now();
  const timer = setInterval(() => {
    if (done || performance.now() - started > 90000) {
      clearInterval(timer);
      return;
    }
    check();
  }, 2500);
})();
